module.exports = __webpack_public_path__ + "static/media/joinUs_bg.700bac3e.png";